export type TopAnalyticsItemDto =
  | RisersDto
  | FallersDto
  | TopTradedBoughtDto
  | TopTradedSoldDto
  | MostVolatileDto
  | MostFollowedDto

export interface RisersDto {
  instrumentSymbol: string | null
  instrumentName: string | null
  instrumentCategory: string | null
  averagePriceChangePercentage: number
  rank: number
}

export interface FallersDto {
  instrumentSymbol: string | null
  instrumentName: string | null
  instrumentCategory: string | null
  averagePriceChangePercentage: number
  rank: number
}

export interface TopTradedBoughtDto {
  instrumentSymbol: string | null
  instrumentName: string | null
  instrumentCategory: string | null
  buyRatioPercentage: number
  rank: number
}

export interface TopTradedSoldDto {
  instrumentSymbol: string | null
  instrumentName: string | null
  instrumentCategory: string | null
  sellRatioPercentage: number
  rank: number
}

export interface MostVolatileDto {
  instrumentSymbol: string | null
  instrumentName: string | null
  instrumentCategory: string | null
  averageVolatilityPercentage: number
  rank: number
}

export interface MostFollowedDto {
  instrumentSymbol: string | null
  instrumentName: string | null
  instrumentCategory: string | null
  followInstrumentRatio: number
  rank: number
}

export enum AnalyticsAssetType {
  Commodities = 'Commodities',
  Crypto = 'Crypto',
  Forex = 'Forex',
  Indices = 'Indices',
}

export enum AnalyticsPeriodType {
  DAY = 1,
  WEEK = 2,
  MONTH = 3,
}

export const isAnalyticsPriceChangeItem = (
  item: TopAnalyticsItemDto
): item is RisersDto | FallersDto => 'averagePriceChangePercentage' in item

export const isAnalyticsBuyRatioItem = (item: TopAnalyticsItemDto): item is TopTradedBoughtDto =>
  'buyRatioPercentage' in item

export const isAnalyticsSellRatioItem = (item: TopAnalyticsItemDto): item is TopTradedSoldDto =>
  'sellRatioPercentage' in item

export const isAnalyticsVolatilityItem = (item: TopAnalyticsItemDto): item is MostVolatileDto =>
  'averageVolatilityPercentage' in item

export const isAnalyticsFollowRatioItem = (item: TopAnalyticsItemDto): item is MostFollowedDto =>
  'followInstrumentRatio' in item
